import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import _ from "lodash";
import { Grid, Button, Rating } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ComponentError from "../../components/404/ComponentError";
import ProductTabs from "./alltab";
import ReactImageGallery from "react-image-gallery";
import {
  ShimmerButton,
  ShimmerThumbnail,
  ShimmerTitle,
} from "react-shimmer-effects";
import "react-medium-image-zoom/dist/styles.css";
import { checkLoggedIn } from "../../utils";
import DeleteIcon from "../../icons/DeleteIcon";
import BuyNowIcon from "../../icons/BuyNowIcon";
import { MoonLoader } from "react-spinners";
import { useLoginModal } from "../../Context/LoginModalContext";
import TrackVisitedProduct from "../../Hooks/useTrackVisitedProduct";
import "./index.css";
import { toast } from "react-toastify";

const Product = ({
  token,
  carts,
  w_list,
  addToCart,
  addToCartProduct,
  removeFromCart,
  incrementQuantity,
  decrementQuantity,
  addToCartBundle,
  ...props
}) => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { openLoginModal } = useLoginModal();

  const [singleProduct, setSingleProduct] = useState(null);
  const [loading, setLoading] = useState(false);
  const [minprice, setMinPrice] = useState(0);
  const [maxprice, setMaxPrice] = useState(0);
  const [bundleQuantities, setBundleQuantities] = useState({});
  const [error, setError] = useState(false);
  const [cartloader, setCartLoader] = useState(false);
  const [loadingItemId, setLoadingItemId] = useState(null);
  const [loadingState, setLoadingState] = useState({
    buyNow: false,
    addToCart: false,
    increment: false,
    decrement: false,
  });

  const inCart = useMemo(() => {
    return carts.find((cart) => cart.id === singleProduct?.id);
  }, [carts, singleProduct]);

  const inWishList = useMemo(() => {
    return w_list?.find((wish) => wish.id === singleProduct?.id);
  }, [w_list, singleProduct]);

  const getSingleProductData = async () => {
    setLoading(true);
    if (error) setError(false);
    await axios
      .get("get-products/latest", {
        params: { slug },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        let singleProduct = {
          ...res?.data?.data?.[0],
          id: res?.data?.data?.[0]?._id,
        };
        if (res?.data?.data?.[0]?.pricebundle?.length > 0) {
          setMaxPrice(res?.data?.data?.[0]?.pricebundle[0]?.price);
          setMinPrice(
            res?.data?.data?.[0]?.pricebundle[
              res?.data?.data?.[0]?.pricebundle.length - 1
            ]?.price
          );
        }
        TrackVisitedProduct({ productId: res?.data?.data?.[0]?._id, token });
        setSingleProduct(singleProduct);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setError(true);
      });
  };

  useEffect(() => {
    getSingleProductData();
  }, [slug]);

  const handleAddToCart = async () => {
    if (checkLoggedIn()) {
      setLoadingState({ ...loadingState, addToCart: true });
      await addToCartProduct(singleProduct);
      setLoadingState({ ...loadingState, addToCart: false });
    } else {
      setLoadingState({ ...loadingState, addToCart: true });
      setTimeout(() => {
        addToCartProduct(singleProduct);
        setLoadingState({ ...loadingState, addToCart: false });
      }, 1000);
    }
  };

  const handleIncrementQuantity = async () => {
    if (checkLoggedIn()) {
      setLoadingState({ ...loadingState, increment: true });
      await incrementQuantity(singleProduct.id);
      setLoadingState({ ...loadingState, increment: false });
    } else {
      setLoadingState({ ...loadingState, increment: true });
      setTimeout(() => {
        incrementQuantity(singleProduct.id);
        setLoadingState({ ...loadingState, increment: false });
      }, 1000);
    }
  };

  const handleDecrementQuantity = async () => {
    if (checkLoggedIn()) {
      setLoadingState({ ...loadingState, decrement: true });
      if (inCart.qty === 1) {
        await removeFromCart(singleProduct.id);
      } else {
        await decrementQuantity(singleProduct.id);
      }
      setLoadingState({ ...loadingState, decrement: false });
    } else {
      setLoadingState({ ...loadingState, decrement: true });
      if (inCart.qty === 1) {
        setTimeout(() => {
          removeFromCart(singleProduct.id);
          setLoadingState({ ...loadingState, decrement: false });
        }, 1000);
      } else {
        setTimeout(() => {
          decrementQuantity(singleProduct.id);
          setLoadingState({ ...loadingState, decrement: false });
        }, 1000);
      }
    }
  };

  const handleBundleAddToCart = async (
    bundlePrice,
    bundleQty,
    productId,
    itemId,
    singleProduct
  ) => {
    setLoadingItemId(itemId);
    setCartLoader(true);
    const selectedQty = bundleQuantities[productId] || 1;
    const finalPrice = Number(bundlePrice) * selectedQty;
    console.log(bundlePrice, bundleQty, productId, selectedQty, finalPrice);

    if (!token) {
      setLoadingItemId("");
      setCartLoader(false);
      toast.error("Please login to add this product to cart.");
      return;
    }

    try {
      addToCartBundle(
        bundlePrice,
        bundleQty,
        productId,
        selectedQty,
        finalPrice,
        singleProduct
      );
      setTimeout(() => {
        setLoadingItemId("");
      }, 2000);
    } catch (error) {
      setLoadingItemId("");
      setTimeout(() => {
        setCartLoader(false);
      }, 2000);
      toast.error("Failed to add item to cart.");
    }

    // if (checkLoggedIn()) {
    //   await addToCartProduct(singleProduct);
    // } else {
    //   setTimeout(() => {
    //     addToCartProduct(singleProduct);
    //   }, 1000);
    // }
  };

  return (
    <div className="product-details single-product">
      {loading ? (
        <div className="row h-full h-400">
          <div className="col-lg-5">
            <ShimmerThumbnail fitOnFrame />
          </div>
          <div className="col-lg-7">
            <ShimmerTitle line={4} gap={20} variant="primary" />
            <div className="flex gap-20">
              <ShimmerButton size="md" />
              <ShimmerButton size="md" />
            </div>
          </div>
        </div>
      ) : error && _?.isEmpty(singleProduct) ? (
        <ComponentError
          heading="Cannot load the Product"
          description="There Must Be Some Error In the Product Name"
        />
      ) : (
        <>
          <div className="row">
            {!_.isEmpty(singleProduct?.proimg) && (
              <div className="col-lg-5">
                <div
                  className="product-single-image"
                  style={{
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                  }}
                >
                  {/* <ul className="tag-wrap" style={{ zIndex: 1 }}>
                    {singleProduct?.badges?.length > 0 &&
                      singleProduct?.badges?.map((badge, index) => (
                        <li className={`tag ${badge}`} key={badge + index}>
                          {badge}
                        </li>
                      ))}
                  </ul> */}

                  {singleProduct?.is_price_bundle ? (
                    <ul className="tag-wrap z-[-100] imag-three">
                      <li className="tag bg-red-600 text-white font-semibold off-per">
                        {(
                          ((Number(
                            singleProduct.pricebundle[0].price
                          ) -
                            Number(
                              singleProduct.pricebundle[
                                singleProduct?.pricebundle?.length - 1
                              ].price)) /
                            Number(singleProduct.pricebundle[0].price)) *
                          100
                        ).toFixed(0)}{" "}
                        % Off
                      </li>
                    </ul>
                  ) : (
                    <ul className="tag-wrap z-[-100] imag-three">
                      {singleProduct.delPrice &&
                        Math.round(
                          ((singleProduct.delPrice - singleProduct.price) /
                            singleProduct.delPrice) *
                            100
                        ) > 0 && (
                          <li className="tag bg-red-600 text-white font-semibold off-per">
                            {Math.round(
                              ((singleProduct.delPrice - singleProduct.price) /
                                singleProduct.delPrice) *
                                100
                            )}
                            % OFF
                          </li>
                        )}
                    </ul>
                  )}
                  <ReactImageGallery
                    showPlayButton={false}
                    autoPlay={false}
                    items={singleProduct?.proimg?.map((image) => ({
                      original: image?.src,
                      thumbnail: image?.src,
                    }))}
                  />
                </div>
              </div>
            )}
            <div className="col-lg-7">
              <div
                className="product-single-content"
                style={{
                  padding: "24px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  backgroundColor: "#fff",
                }}
              >
                <h5>{singleProduct?.title}</h5>
                {/* <p>{singleProduct?.description}</p> */}

                <div className="flex items-center gap-10 mb-10">
                  <Rating
                    name="read-only"
                    precision={0.5}
                    value={+singleProduct?.five_start_rating}
                    readOnly
                    className="mt-2"
                  />
                  <span className="mt-2">
                    {singleProduct?.five_start_rating || 0}
                  </span>
                </div>

                {/* <span className="present-price">${singleProduct?.price}</span>
                <del className="old-price">${singleProduct?.delPrice}</del> */}

                {minprice > 0 ? (
                  <span className="present-price">
                    ${minprice} - ${maxprice} Per Pill
                  </span>
                ) : (
                  <span className="present-price">${singleProduct?.price}</span>
                )}

                <div className="stock">
                  <ul>
                    <li>
                      <li style={{ color: "green", fontWeight: "bolder" }}>
                        {singleProduct?.stock > 0 ? "In Stock" : "Out Of Stock"}
                      </li>
                    </li>
                  </ul>
                </div>

                <div className="category">
                  <p className="mb-1 mt-2">
                    Category : {singleProduct?.category}
                  </p>
                  <p className="mb-1">Brand : {singleProduct?.brand}</p>
                  {singleProduct?.is_price_bundle && (
                    window.innerWidth <= 600 ? (
                      // Mobile: Dropdown for bundle selection
                      <div className="mobile-bundle-dropdown mt-4 mb-4">
                        {/* Bundle select full width */}
                        <select
                          className="border rounded px-2 py-2 w-full mb-2"
                          value={
                            singleProduct?.pricebundle?.find(
                              (pb) => pb._id === Object.keys(bundleQuantities)[0]
                            )?._id || singleProduct?.pricebundle?.[0]?._id
                          }
                          onChange={(e) => {
                            setBundleQuantities({
                              [e.target.value]: bundleQuantities[e.target.value] || 1,
                            });
                          }}
                        >
                          {singleProduct?.pricebundle?.map((item, idx) => (
                            <option key={item._id} value={item._id}>
                              {item.qty} Tablet/s - $
                              {Number(item.price * item.qty).toFixed(2)}
                              {idx === 0
                                ? ""
                                : ` (${(
                                    ((Number(singleProduct.pricebundle[0].price) - Number(item.price)) /
                                      Number(singleProduct.pricebundle[0].price)) *
                                    100
                                  ).toFixed(0)}% off)`}
                            </option>
                          ))}
                        </select>
                        {/* Qty select full width */}
                        <div className="mb-2 w-full">
                          <label className="block mb-1 font-medium">Qty:</label>
                          <select
                            className="border rounded px-2 py-2 w-full"
                            value={bundleQuantities[Object.keys(bundleQuantities)[0]] || 1}
                            onChange={(e) =>
                              setBundleQuantities((prev) => ({
                                ...prev,
                                [Object.keys(bundleQuantities)[0]]: Number(e.target.value),
                              }))
                            }
                          >
                            {[...Array(2)].map((_, i) => (
                              <option key={i + 1} value={i + 1}>
                                {i + 1}
                              </option>
                            ))}
                          </select>
                        </div>
                        {/* Add to Cart button full width */}
                        <button
                          className="cart-btn-full-main flex items-center justify-center gap-2 w-full"
                          style={{ width: "100%" }}
                          onClick={() => {
                            const selectedId =
                              Object.keys(bundleQuantities)[0] ||
                              singleProduct?.pricebundle?.[0]?._id;
                            const selectedBundle = singleProduct?.pricebundle?.find(
                              (pb) => pb._id === selectedId
                            );
                            const qty = bundleQuantities[selectedId] || 1;
                            const bundlePrice = Number(
                              selectedBundle.price * selectedBundle.qty * qty
                            ).toFixed(2);
                            handleBundleAddToCart(
                              bundlePrice,
                              selectedBundle.qty,
                              singleProduct._id,
                              selectedBundle._id,
                              singleProduct
                            );
                          }}
                          disabled={
                            loadingItemId ===
                            (Object.keys(bundleQuantities)[0] ||
                              singleProduct?.pricebundle?.[0]?._id)
                          }
                        >
                          {loadingItemId ===
                          (Object.keys(bundleQuantities)[0] ||
                            singleProduct?.pricebundle?.[0]?._id) ? (
                            <MoonLoader size={16} color="#fafafa" />
                          ) : (
                            <>
                              <i className="icon-cart" style={{ marginRight: 10 }}></i>
                              <span>Add to Cart</span>
                            </>
                          )}
                        </button>
                      </div>
                    ) : (
                      // Desktop: Table
                      <div
                        className="responsive-table-wrapper"
                        style={{
                          overflowX: "auto",
                          width: "100%",
                          marginBottom: 16,
                        }}
                      >
                        <table
                          className="w-full mt-4 border-collapse justify-center text-center"
                          style={{
                            minWidth: 520,
                            fontSize:
                              window.innerWidth <= 600 ? "13px" : "inherit",
                          }}
                        >
                          <thead>
                            <tr className="cart-table-header">
                              <th className="border p-2 text-white">Pack Size</th>
                              <th className="border p-2 text-white">Qty</th>
                              <th className="border p-2 text-white w-150">
                                Price Per Pill or Unit
                              </th>
                              <th className="border p-2 text-white">Price</th>
                              <th className="border p-2 text-white">Cart</th>
                            </tr>
                          </thead>
                          <tbody>
                            {singleProduct?.pricebundle?.map((item, index) => {
                              const selectedQty = bundleQuantities[item._id] || 1;
                              const totalPrice = item.qty * item.price;
                              const bundlePrice = Number(
                                item.price * item.qty
                              ).toFixed(2);

                              return (
                                <tr key={index}>
                                  <td className="border p-2">
                                    {item.qty} Tablet/s
                                  </td>

                                  <td className="border p-2">
                                    <select
                                      name="qty-select"
                                      className="border rounded px-2 py-1"
                                      value={bundleQuantities[item._id] || 1}
                                      onChange={(e) =>
                                        setBundleQuantities((prev) => ({
                                          ...prev,
                                          [item._id]: Number(e.target.value),
                                        }))
                                      }
                                    >
                                      {[...Array(2)].map((_, i) => (
                                        <option key={i + 1} value={i + 1}>
                                          {i + 1}
                                        </option>
                                      ))}
                                    </select>
                                  </td>

                                  <td className="border p-2">
                                    <p className="text-black font-bold">
                                      $ {Number(item.price).toFixed(2)}
                                    </p>
                                  </td>

                                  {index === 0 ? (
                                    <td className="border p-2">
                                      <p className="text-black font-bold font-one">
                                        {" "}
                                        $ {Number(item.price * item.qty).toFixed(2)}
                                      </p>
                                    </td>
                                  ) : (
                                    <td className="border p-2">
                                      <p className="text-black font-bold font-one">
                                        $ {Number(item.price * item.qty).toFixed(2)}
                                      </p>
                                      <div className="flex flex-row gap-2 text-center justify-center">
                                        <p className="text-red-600 font-bold text-sm font-one">
                                          {(
                                            ((Number(
                                              singleProduct.pricebundle[0].price
                                            ) -
                                              Number(item.price)) /
                                              Number(
                                                singleProduct.pricebundle[0].price
                                              )) *
                                            100
                                          ).toFixed(0)}
                                          % off
                                        </p>
                                        <p className="text-gray-500 font-semibold text-sm line-through font-two">
                                          $
                                          {Number(
                                            singleProduct.pricebundle[0].price *
                                              item.qty
                                          ).toFixed(2)}
                                        </p>
                                      </div>
                                    </td>
                                  )}

                                  <td className="border p-2 text-center align-middle">
                                    <div className="flex justify-center items-center h-full">
                                      <button
                                        className="cart-btn-full-main flex items-center justify-center gap-2"
                                        onClick={() =>
                                          handleBundleAddToCart(
                                            bundlePrice,
                                            item.qty,
                                            singleProduct._id,
                                            item._id,
                                            singleProduct
                                          )
                                        }
                                        disabled={loadingItemId === item._id}
                                      >
                                        {loadingItemId === item._id ? (
                                          <MoonLoader size={16} color="#fafafa" />
                                        ) : (
                                          <>
                                            <i
                                              className="icon-cart"
                                              style={{ marginRight: 10 }}
                                            ></i>
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )
                  )}
                  {!singleProduct?.is_price_bundle && (
                    <div>
                      {singleProduct?.stock > 0 ? (
                        <div className="pro-single-btn">
                          <button
                            className="buy-now-btn me-2"
                            onClick={async () => {
                              if (!checkLoggedIn()) {
                                setLoadingState({
                                  ...loadingState,
                                  buyNow: true,
                                });
                                await addToCartProduct(singleProduct);
                                setLoadingState({
                                  ...loadingState,
                                  buyNow: false,
                                });
                                navigate("/cart");
                              } else if (inCart) {
                                navigate("/cart");
                              } else {
                                setLoadingState({
                                  ...loadingState,
                                  buyNow: true,
                                });
                                await addToCartProduct(singleProduct);
                                setLoadingState({
                                  ...loadingState,
                                  buyNow: false,
                                });
                                navigate("/cart");
                              }
                            }}
                            disabled={
                              loadingState.buyNow ||
                              loadingState.addToCart ||
                              loadingState.increment ||
                              loadingState.decrement
                            }
                          >
                            {loadingState.buyNow ? (
                              <MoonLoader size={16} color="#fafafa" />
                            ) : (
                              <BuyNowIcon />
                            )}
                            Buy Now
                          </button>

                          {/* {inCart ? (
                        <Grid className="flex items-center gap-10">
                          <button
                            className="decQtybutton"
                            onClick={() => handleDecrementQuantity()}
                            disabled={
                              loadingState.buyNow ||
                              loadingState.addToCart ||
                              loadingState.increment ||
                              loadingState.decrement
                            }
                          >
                            {loadingState.decrement ? (
                              <MoonLoader size={16} color="#fafafa" />
                            ) : inCart.qty === 1 ? (
                              <DeleteIcon />
                            ) : (
                              "-"
                            )}
                          </button>
                          <h2>{inCart?.qty}</h2>
                          <button
                            className="incQtybutton"
                            onClick={handleIncrementQuantity}
                            disabled={
                              loadingState.buyNow ||
                              loadingState.addToCart ||
                              loadingState.increment ||
                              loadingState.decrement
                            }
                          >
                            {loadingState.increment ? (
                              <MoonLoader size={16} color="#fafafa" />
                            ) : (
                              "+"
                            )}
                          </button>
                        </Grid>
                      ) : (
                        <button
                          className="cart-btn-full"
                          onClick={handleAddToCart}
                          disabled={
                            loadingState.buyNow ||
                            loadingState.addToCart ||
                            loadingState.increment ||
                            loadingState.decrement
                          }
                        >
                          {loadingState.addToCart ? (
                            <MoonLoader size={16} color="#fafafa" />
                          ) : (
                            <i className="icon-cart" style={{ marginRight: 10 }}></i>
                          )}
                        </button>
                      )} */}

                          <button
                            className="cart-btn-full"
                            onClick={handleAddToCart}
                            disabled={
                              loadingState.buyNow ||
                              loadingState.addToCart ||
                              loadingState.increment ||
                              loadingState.decrement
                            }
                          >
                            {loadingState.addToCart ? (
                              <MoonLoader size={16} color="#fafafa" />
                            ) : (
                              <>
                                <i
                                  className="icon-cart"
                                  style={{ marginRight: 10 }}
                                ></i>
                                <span>Add to Cart</span>
                              </>
                            )}
                          </button>
                        </div>
                      ) : (
                        <p
                          style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            color: "black",
                          }}
                          className="bold p-1 mt-5"
                        >
                          Out of stock
                        </p>
                      )}{" "}
                    </div>
                  )}

                  <br />
                  <p className="mb-1">
                    <span style={{ fontWeight: "800" }}>Description :</span>{" "}
                    {singleProduct?.sub_detailed_description}
                  </p>
                  <br />
                  <p className="mb-1">
                    <span style={{ fontWeight: "800" }}>How to Use :</span>
                    <br /> {singleProduct?.how_to_use}
                  </p>
                  <br />
                  {singleProduct?.benefits && (
                    <div className="mb-1">
                      <p className="font-semibold">
                        <span style={{ fontWeight: "800" }}>
                          Benefits: <br />
                        </span>
                      </p>
                      <ul className="">
                        {(singleProduct?.benefits || "")
                          .split(/\n{2,}|\r?\n/g)
                          .filter((item) => item.trim() !== "")
                          .map((item, index) => (
                            <>
                              <li id="list-bullet-points" key={index}>
                                {item.trim()}
                              </li>
                              <br />
                            </>
                          ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Product;